import { render, staticRenderFns } from "./ClickAndHighlightableTextSpan.vue?vue&type=template&id=473f0bd2&scoped=true"
import script from "./ClickAndHighlightableTextSpan.vue?vue&type=script&lang=js"
export * from "./ClickAndHighlightableTextSpan.vue?vue&type=script&lang=js"
import style0 from "./ClickAndHighlightableTextSpan.vue?vue&type=style&index=0&id=473f0bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f0bd2",
  null
  
)

export default component.exports